var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-container" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-12" },
        [
          _c("div", { staticClass: "title-container" }, [
            _c("h6", [_vm._v(_vm._s(_vm.currentStep.title))]),
          ]),
          _vm._v(" "),
          _c("retirement-information-form"),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 button-group" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-lg btn-default",
            attrs: { type: "button" },
            on: { click: _vm.setPreviousStep },
          },
          [
            _c("i", { staticClass: "fa fa-caret-left" }),
            _vm._v("\n        Previous\n      "),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-lg btn-primary",
            attrs: {
              type: "button",
              disabled: !_vm.retirementInformationIsValid,
            },
            on: { click: _vm.setNextStep },
          },
          [
            _vm._v("\n        Continue\n        "),
            _c("i", { staticClass: "fa fa-caret-right" }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }